import { create } from "zustand";

const useContactStore = create((set) => ({
    contactPersons: [],
    
    // Function to add a new contact person
    addContactPerson: (newPerson) =>
        set((state) => ({
            contactPersons: [...state.contactPersons, { ...newPerson, id: state.contactPersons.length + 1 }],
        })),

    // Function to remove a contact person by ID
    removeContactPerson: (id) =>
        set((state) => ({
            contactPersons: state.contactPersons.filter(person => person.id !== id),
        })),

    resetContactPersons: () => set({ contactPersons: [] })
}));

export default useContactStore;
